<template>
    <div class="ibox px-4">
        <div class="ibox-title dashboard_title company-form-box-title pf-contribution pl-0">
        </div>
        <div class="gf-grid pr-2 my-2 pb-4">
            
            <!-- Outgoing Members & Paid Amount-->
            <div class="gf-card">
                <div class="gf-card-title ml-3">Outgoing Members & Paid Amount</div>
                <div class="report-button-contents mb-4 ml-3">
                    <div class="row">
                        <div class="col-3">
                            <label for="">Select Year:</label>
                            <b-form-select class="" v-model="selected_former_member_year">
                                <b-form-select-option disabled value="" selected>Select Year</b-form-select-option>
                                <b-form-select-option v-for="(year, index) in former_member_years" :key="index"
                                    :value="year.value">{{ year.label }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col-3">
                            <label for="">Select Half:</label>
                            <b-form-select class="" v-model="selected_former_member_half">
                                <b-form-select-option disabled value="" selected>Select Half</b-form-select-option>
                                <b-form-select-option v-for="(half, index) in total_halves" :key="index"
                                    :value="half.value">{{ half.text }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col d-flex justify-content-end align-items-center pr-3" style="margin-top: 32px;">
                            <b-button size="sm" variant="primary" @click="exportOutgoingMembers">
                                <i class="fa fa-download"></i> Export
                            </b-button>
                        </div>
                    </div>
                </div>
                <b-overlay :show="formerMemberShowOverlay" rounded="sm" class="full-overlay">
                <gf-outgoing-members-bar
                    :key="outgoing_members_chart_key"
                    ref="outgoingMembers"
                    :periods="former_member_periods_show"
                    :outgoing-counts="former_member.counts"
                    :paid-amounts-cr="former_member.paidCr" />
                </b-overlay>
            </div>

            <!-- GF Payable and Paid -->
            <div class="gf-card">
                <div class="d-flex justify-content-between align-items-center mr-3">
                    <div class="gf-card-title ml-3">GF Payable and Paid</div>
                    <div class="text-muted">As of {{ current_date }}</div>
                </div>
                <b-overlay :show="totalContributionShowOverlay" rounded="sm" class="full-overlay">
                    <div class="col-md-12 border-0 mb-4" style="margin-top: 32px;">
                        <div class="ibox-title company-form-box-title card-highlight">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <div class="text-muted card-label">Employees with GF Payable</div>
                                    <div class="card-number">{{ gf_payable_and_paid.total_employees }}</div>
                                    <div class="card-sub-label">Total Payable Amount: <strong>{{ formatMoney(gf_payable_and_paid.total_payable_amount) }}</strong></div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-money-bill text-primary card-icon"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 border-0 mb-4">
                        <div class="ibox-title company-form-box-title card-highlight">
                            <div class="d-flex justify-content-between align-items-center">
                                <div>
                                    <div class="text-muted card-label">Employees Paid</div>
                                    <div class="card-number">{{ gf_payable_and_paid.total_employees_paid }}</div>
                                    <div class="card-sub-label">Total Paid Amount: <strong>{{ formatMoney(gf_payable_and_paid.total_paid_amount) }}</strong></div>
                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="fa fa-hand-holding-usd text-primary card-icon"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </div>

            <!-- GF Membership Status -->
            <div class="gf-card">
                <div class="gf-card-title ml-3">GF Membership Status</div>
                <div class="report-button-contents mb-4 ml-3">
                    <div class="row">
                        <div class="col-3">
                            <label for="">Select Year:</label>
                            <b-form-select class="" v-model="selected_gf_membership_year">
                                <b-form-select-option disabled value="" selected>Select Year</b-form-select-option>
                                <b-form-select-option v-for="(period, index) in gf_membership_years" :key="index"
                                    :value="period.value">{{ period.label }}</b-form-select-option>
                            </b-form-select>
                        </div>
                        <div class="col-3">
                            <label for="">Select Half:</label>
                            <b-form-select class="" v-model="selected_gf_membership_month">
                                <b-form-select-option disabled value="" selected>Select Month</b-form-select-option>
                                <b-form-select-option v-for="(half, index) in gf_membership_months" :key="index"
                                    :value="half.value">{{ half.text }}</b-form-select-option>
                            </b-form-select>
                        </div>
                    </div>
                </div>
                <b-overlay :show="membershipShowOverlay" rounded="sm" class="full-overlay">
                <gf-membership-status-chart :gf_membership_status="gf_membership_status"/>
                </b-overlay>
            </div>

        </div>
    </div>

</template>

<script>
export default {
    name: 'GFDashboard',
    data() {
        return {
            total_halves: [
                { value: 1, text: '1st Half' },
                { value: 2, text: '2nd Half' }
            ],

            month_names: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

            // Former Member
            selected_former_member_year: '',
            selected_former_member_half: '',
            former_member_years: this.generateYears(),
            former_member_periods_show: [],
            former_member: {
                counts: [],
                paidCr: [],
            },

            // GF Payable and Paid
            gf_payable_and_paid: {
                total_employees: 0,
                total_payable_amount: 0,
                total_employees_paid: 0,
                total_paid_amount: 0,
            },

            // GF Membership Status
            selected_gf_membership_year: new Date().getFullYear(),
            selected_gf_membership_month: String(new Date().getMonth() + 1),

            gf_membership_years: Array.from(
                { length: new Date().getFullYear() - 2020 + 1 },
                (_, i) => ({ value: 2020 + i, label: String(2020 + i) })
            ),

            gf_membership_months: [
                { value: "1", text: "January" },
                { value: "2", text: "February" },
                { value: "3", text: "March" },
                { value: "4", text: "April" },
                { value: "5", text: "May" },
                { value: "6", text: "June" },
                { value: "7", text: "July" },
                { value: "8", text: "August" },
                { value: "9", text: "September" },
                { value: "10", text: "October" },
                { value: "11", text: "November" },
                { value: "12", text: "December" },
            ],

            gf_membership_status: {},

            current_date: null,

            formerMemberShowOverlay: false,
            totalContributionShowOverlay: false,
            membershipShowOverlay: false,
            outgoing_members_chart_key: 0,
        };
    },

    watch: {
        selected_former_member_year() {
            this.getFormerMemberChart();
        },
        selected_former_member_half() {
            this.getFormerMemberChart();
        },

        selected_gf_membership_year() {
            this.getGfMembershipStatusChart();
        },
        selected_gf_membership_month() {
            this.getGfMembershipStatusChart();
        },
    },
    methods: {
        exportOutgoingMembers() {
            try {
                this.$refs.outgoingMembers?.exportPng('Outgoing_Members_Paid_Amount_GF.png');
            } catch (e) {
                console.error('Export failed:', e);
            }
        },

        generateYears() {
            const periods = [];
            const currentYear = new Date().getFullYear();

            for (let year = currentYear; year >= 2020; year--) {
                periods.push({
                    value: `${year}-${year + 1}`,
                    label: `${year}-${year + 1}`
                });
            }

            return periods;
        },

        getFormerMemberChart() {
            this.formerMemberShowOverlay = true;
            if (!this.selected_former_member_year || !this.selected_former_member_half) {
                this.formerMemberShowOverlay = false;
                return;
            }

            let url = this.$api_url + '/gf/trustee/get-former-member-chart-data';

            let formData = new FormData();

            formData.append('year', this.selected_former_member_year);
            formData.append('half', this.selected_former_member_half);

            axios.post(url, formData).then(function (response) {
                this.formerMemberShowOverlay = false;
                if (response.data.errors) {
                    return;
                }

                const data = response.data;
                this.former_member_periods_show = [];
                this.former_member.counts = [];
                this.former_member.paidCr = [];

                Object.keys(data).sort().forEach(dateStr => {
                    const item = data[dateStr];

                    const date = new Date(dateStr);
                    const half = (date.getMonth() < 6) ? "H1" : "H2";
                    const formattedPeriod = `${half}'${String(date.getFullYear()).slice(-2)}`;

                    this.former_member_periods_show.push(formattedPeriod);

                    this.former_member.counts.push(item.total_leavers);
                    this.former_member.paidCr.push(item.total_paid_amount);
                });
                this.outgoing_members_chart_key += 1;
            }.bind(this))
                .catch(error => {
                    this.formerMemberShowOverlay = false;
                    if (error.response) {
                    }
                });
        },

        getEmployerContribution() {
            this.totalContributionShowOverlay = true;

            let url = this.$api_url + '/gf/trustee/get-employer-contribution';

            axios.post(url).then(function (response) {
                this.totalContributionShowOverlay = false;
                if (response.data.errors) {
                    return;
                }
                this.gf_payable_and_paid.total_employees = response.data.total_employees;
                this.gf_payable_and_paid.total_payable_amount = response.data.total_payable_amount;
                this.gf_payable_and_paid.total_employees_paid = response.data.total_employees_paid;
                this.gf_payable_and_paid.total_paid_amount = response.data.total_paid_amount;
            }.bind(this))
                .catch(error => {
                    this.totalContributionShowOverlay = false;
                    if (error.response) {
                    }
                });
        },

        getGfMembershipStatusChart() {
            this.membershipShowOverlay = true;
            if (!this.selected_gf_membership_year || !this.selected_gf_membership_month) {
                this.membershipShowOverlay = false;
                return;
            }

            let url = this.$api_url + '/gf/trustee/get-membership-status-chart-data';

            let formData = new FormData();

            formData.append('year', this.selected_gf_membership_year);
            formData.append('month', this.selected_gf_membership_month);

            axios.post(url, formData).then(function (response) {
                this.membershipShowOverlay = false;
                if (response.data.errors) {
                    return;
                }
                this.gf_membership_status = response.data;
            }.bind(this))
            .catch(error => {
                this.membershipShowOverlay = false;
                if (error.response) {
                }
            });
        },
    },
    mounted() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1);

        this.current_date = today.toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });

        this.selected_former_member_year = (year - 1) + '-' + year;
        this.selected_former_member_half = 1;

        this.selected_gf_membership_year = year;
        this.selected_gf_membership_month = month;

        this.getFormerMemberChart();
        this.getEmployerContribution();
        this.getGfMembershipStatusChart();
    },

    computed: {}
};
</script>

<style scoped>
.gf-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 18px;
}

.gf-card {
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 14px;
    padding: 12px 14px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .04);
}

.gf-card-title {
    font-weight: 600;
    margin: 2px 0 8px;
    color: #0064b5;
    font-size: 20px;
}

.card-highlight {
    background-color: #a0ded7;
    border-radius: 8px;
    padding: 20px;
}

.card-label {
    font-size: 15px;
}

.card-number {
    font-size: 24px;
    font-weight: bold;
}

.card-sub-label {
    font-size: 13.5px;
    color: #555;
    margin-top: 2px;
}

.card-icon {
    font-size: 36px;
}

@media (max-width: 1024px) {
    .gf-grid {
        grid-template-columns: 1fr;
    }
}
</style>
